import { TextCapitalized, Spacer, ButtonDS, PageDS } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { createMemobankMandateAsync } from "../sepaDebitSlice";
import { selectCompany, selectManager } from "../../homeSlice";
import { useNavigate, useParams } from "react-router-dom";
import { sepaDebitSlice } from "../sepaDebitSlice";
import "../../../../i18n/i18n";
import useFullScreen from "../../../../hooks/useFullScreen";

export const MemobankMandatePage = () => {
  useFullScreen();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const company = useAppSelector(selectCompany);
  const manager = useAppSelector(selectManager);
  const clickToSubmit = () => {
    if (!company) return;
    void dispatch(sepaDebitSlice.actions.setMemobankMandateSent(true));
    void dispatch(
      createMemobankMandateAsync({
        companyUuid: company.uuid,
      }),
    );
    navigate(`/home/billings/account`);
  };

  useEffect(() => {
    if (params.sepa_debit === "mandate_signature_request") {
      navigate(`/home/billings/account`);
    }
  }, [navigate, params.sepa_debit, company?.canActivatePlatformSepaDebit]);

  if (!company || !manager) return null;

  return (
    <PageDS
      isFullScreen
      title={t("account.mandate_signature_request.modal.title")}
      titleElement={{
        closeButtonAction: () => navigate(`/home/billings/account`),
      }}
    >
      <StyledContainer>
        <StyledModal>
          <StyledConditionsCard>
            <Spacer x={1.5} />
            <StyledDescription>
              <Spacer y={1.5} />
              <TextCapitalized>
                {t("account.memobank.mandate.modal.description")}
              </TextCapitalized>
              <Spacer y={1.5} />
            </StyledDescription>
            <Spacer x={1.5} />
          </StyledConditionsCard>
          <StyledManagerCard>
            <Spacer y={1.5} />
            <StyledRow>
              <Spacer x={1.5} />
              <StyledManagerColumn>
                <TextCapitalized>
                  <StyledManagerTitle>
                    {t("account.sepaDebit.modal.manager.firstName")}
                  </StyledManagerTitle>
                  <Spacer y={0.5} />
                  <StyledManagerSubTitle>
                    {manager.firstName}
                  </StyledManagerSubTitle>
                </TextCapitalized>
              </StyledManagerColumn>
              <StyledManagerColumn>
                <TextCapitalized>
                  <StyledManagerTitle>
                    {t("account.sepaDebit.modal.manager.lastName")}
                  </StyledManagerTitle>
                  <Spacer y={0.5} />
                  <StyledManagerSubTitle>
                    {manager.lastName}
                  </StyledManagerSubTitle>
                </TextCapitalized>
              </StyledManagerColumn>
            </StyledRow>
            <Spacer y={1.5} />
            <StyledRow>
              <Spacer x={1.5} />
              <TextCapitalized>
                <StyledManagerTitle>
                  {t("account.sepaDebit.modal.manager.email")}
                </StyledManagerTitle>
                <Spacer y={0.5} />
                <StyledManagerSubTitle>{manager.email}</StyledManagerSubTitle>
              </TextCapitalized>
            </StyledRow>
            <Spacer y={1.5} />
          </StyledManagerCard>

          <StyledCompanyCard>
            <Spacer y={1.5} />
            <StyledRow>
              <Spacer x={1.5} />
              <TextCapitalized>
                <StyledCompanyTitle>
                  {t("account.sepaDebit.modal.company.name")}
                </StyledCompanyTitle>
                <Spacer y={0.5} />
                <StyledCompanySubTitle>{company.name}</StyledCompanySubTitle>
              </TextCapitalized>
              <Spacer x={1.5} />
            </StyledRow>
            <Spacer y={1.5} />
          </StyledCompanyCard>
          <Spacer y={1.5} />

          <ButtonDS
            sizeButton={"S"}
            format={"hug"}
            buttonType={"primary"}
            text={t("account.memobank.mandate.modal.button")}
            onClick={() => clickToSubmit()}
          />
        </StyledModal>
      </StyledContainer>
    </PageDS>
  );
};

const StyledContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
  width: 100%;
`;

const StyledModal = styled.div`
  width: 30.5rem;
`;

const StyledRow = styled.div`
  display: flex;
`;

const StyledManagerColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const StyledConditionsCard = styled.div`
  display: flex;
  width: 100%;
  background-color: ${colors["colors/borders/cells/cells"]};
  border-radius: 0.5rem 0.5rem 0rem 0rem;
  ${typographies["Paragraph/P2"]};
`;

const StyledDescription = styled.div`
  ${typographies["Body/XS"]};
`;

const StyledManagerCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 0.0625rem solid ${colors["colors/borders/cells/cells"]};
  ${typographies["Paragraph/P2"]};
`;

const StyledManagerTitle = styled.div`
  ${typographies["Body/M"]}
  color: ${colors["colors/text/black"]}
`;

const StyledManagerSubTitle = styled.div`
  ${typographies["Body/S"]}
  color: ${colors["colors/text/black"]}
`;

const StyledCompanyCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 0.0625rem solid ${colors["colors/borders/cells/cells"]};
  border-radius: 0rem 0rem 0.5rem 0.5rem;
  ${typographies["Paragraph/P2"]};
`;

const StyledCompanyTitle = styled.div`
  ${typographies["Body/XXS"]}
  color: ${colors["colors/text/black"]}
`;

const StyledCompanySubTitle = styled.div`
  ${typographies["Body/M"]}
  color: ${colors["colors/text/black"]}
`;
